import styled from "styled-components/macro"

export const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  justify-items: start;
  row-gap: 1rem;
  margin: auto 0;
  min-height: 3rem;
`

export const Column = styled.div`
  display: flex;
  justify-items: start;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.2rem;

  &:nth-child(even) {
    border-left: 1px solid ${({ theme }) => theme.colors.borderDark};
    padding-left: 2rem;
  }
}
`

export const Metric = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.8rem;
`
